export enum FeedVariantE {
    hosts = 'hosts',
    goals = 'goals'
}
